import TrainingWizard from './TrainingWizard'
import TrainingMenuButton from './components/TrainingMenuButton'

export { TrainingWizard, TrainingMenuButton }
export default TrainingWizard
